module.exports = __webpack_public_path__ + "static/media/microsof-excel-logo.1992917f.png";